import React, { useState, useRef, useEffect } from 'react';
import PageLayout from '../../layouts/PageLayout';
import NoLeave from '../../assets/images/noUpcoming.svg';
import { CiFilter } from 'react-icons/ci';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { useLazyGetLeaveRequestsQuery } from '../../features/apis/authApi';
import useCurrentUser from '../../customHook/useCurrentUser';
import { useResolveRequestMutation } from '../../features/apis/requestApi';
import useSendNotification from '../../customHook/useSendNotification';

function getRandomColor() {
  const colors = [
    '#6E3EF5',
    '#34D399',
    '#3B82F6',
    '#F59E0B',
    '#EF4444',
    '#8B5CF6',
    '#10B981',
    '#F472B6',
    '#FCD34D',
    '#60A5FA',
    '#A78BFA',
    '#F87171',
  ];
  return colors[Math.floor(Math.random() * colors.length)];
}

function getInitials(name: string) {
  if (!name) return '';
  const [first = '', second = ''] = name.split(' ');
  return (first.charAt(0) + second.charAt(0)).toUpperCase();
}

const getAvarFromName = (name: string) => {
  const bgColor = getRandomColor();
  return (
    <div
      className="h-10 w-10 rounded-full text-white flex items-center justify-center text-[10px]"
      style={{ backgroundColor: bgColor }}
    >
      {getInitials(name)}
    </div>
  );
};

function ManageLeave() {
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [actionType, setActionType] = useState<'approve' | 'reject' | null>(
    null
  );

  const [getLeave, { data, isFetching }] = useLazyGetLeaveRequestsQuery();

  const user = useCurrentUser();
  const [resolveRequest] = useResolveRequestMutation();
  const { sendNotification } = useSendNotification();
  const filterRef = useRef<HTMLDivElement>(null);
  const menuRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (user?.companyId) getLeave(user.companyId);
  }, [getLeave, user?.companyId]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        setFilterMenuOpen(false);
      }
      if (
        openMenuIndex !== null &&
        menuRefs.current[openMenuIndex] &&
        !menuRefs.current[openMenuIndex]?.contains(event.target as Node)
      ) {
        setOpenMenuIndex(null);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openMenuIndex]);
const formatDateRange = (dateRange: string) => {
  if (!dateRange) return '';
  const [start, end] = dateRange.split(' - ');
  if (!start || !end) return dateRange;
  const startParts = start.split('-');
  const endParts = end.split('-');
  const dayStart = startParts[0];
  const dayEnd = endParts[0];
  const month = endParts[1];
  const year = endParts[2];
  return `${dayStart}-${dayEnd}, ${month}, ${year}`;
};
  const Leavesrequest = data?.data;
  const filteredData = selectedFilter
    ? Leavesrequest?.filter((leave) => leave.status === selectedFilter)
    : Leavesrequest;

  const getStatusBadge = (status: string) => {
    if (status === 'approved')
      return 'bg-[#E8F9EE] text-[#1B7F46] border border-[#6EE7A0]';
    if (status === 'pending')
      return 'bg-[#FFF8E6] text-[#8A6D18] border border-[#FFD580]';
    return 'bg-[#FBECEC] text-[#8B1C1C] border border-[#FFA8A8]';
  };

  const getRoleBadge = (role: string) => {
    const r = (role || '').toLowerCase();
    if (r.includes('admin'))
      return 'bg-[#EDE9FE] text-[#6D28D9] border border-[#C4B5FD]';
    if (r.includes('hr'))
      return 'bg-[#FCE7F3] text-[#9D174D] border border-[#F9A8D4]';
    if (r.includes('employee'))
      return 'bg-[#E0F2FE] text-[#075985] border border-[#7DD3FC]';
    return 'bg-[#F3F4F6] text-[#374151] border border-[#D1D5DB]';
  };

  const openModal = (leave: any) => {
    setSelectedLeave(leave);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedLeave(null);
  };

  const handleApprove = async () => {
    if (!selectedLeave) return;
    setLoading(true);
    setActionType('approve');
    try {
      await resolveRequest({
        id: selectedLeave.id,
        userId: user?._id,
        status: 'approved',
        msg: 'Approved by admin',
      }).unwrap();
      getLeave(user?.companyId);
      console.log(selectedLeave, 'selectedLeave');

      sendNotification({
        userId: selectedLeave.userId,
        type: 'leave_approved',
        data: {
          leaveType: selectedLeave.leaveType,
          dates: selectedLeave.dates,
        },
        isAdmin: false,
      });
      setLoading(false);
      handleCloseModal();
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleReject = async () => {
    if (!selectedLeave) return;
    setLoading(true);
    setActionType('reject');
    try {
      await resolveRequest({
        id: selectedLeave.id,
        userId: user?._id,
        status: 'rejected',
        msg: 'Rejected by admin',
      }).unwrap();
      getLeave(user?.companyId);
      setLoading(false);
      handleCloseModal();
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <PageLayout
      pageTitle="Leave Requests"
      actionButton={
        user?.role !== 'Employe' && (
          <div className="relative" ref={filterRef}>
            <button
            className="bg-gradient-to-r from-[#6E3EF5] to-[#A818D8] hover:from-[#6E3EF5]/80 hover:to-[#A818D8]/80 flex items-center justify-center px-4 py-2 font-inter rounded-md text-white gap-2 hover:scale-105 hover:shadow text-xs md:text-sm add-my-team-btn disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => setFilterMenuOpen(!filterMenuOpen)}
            >
              <CiFilter className="text-white" />
              Filter
            </button>

            {filterMenuOpen && (
               <div className="absolute right-0 mt-2 w-32 bg-white rounded-xl shadow-xl z-20 text-xs py-3 px-2 border border-[#D4D4D4]">
                 <ul className="divide-y divide-[#D4D4D4]">
                  {['approved', 'rejected', 'pending'].map((status) => (
                    <li
                      key={status}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer capitalize"
                      onClick={() => {
                        setSelectedFilter(status);
                        setFilterMenuOpen(false);
                      }}
                    >
                      {status}
                    </li>
                  ))}
                  <li
                    className="px-4 py-2 text-red-500 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedFilter(null);
                      setFilterMenuOpen(false);
                    }}
                  >
                    Clear Filter
                  </li>
                </ul>
              </div>
            )}
          </div>
        )
      }
    >
      <div className="mx-6 mt-6 font-poppins bg-white rounded-lg  shadow-md">
        {isFetching ? (
          <div className="flex flex-col items-center gap-4 py-10">
            {[...Array(4)].map((_, index) => (
              <div
                key={index}
                className="grid grid-cols-5 items-center py-4 px-6 border-b-[0.5px] border-[#D4D4D4] w-full"
              >
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse shrink-0" />
                  <div className="flex flex-col gap-1.5">
                    <div className="h-3 bg-gray-200 rounded w-24 animate-pulse" />
                    <div className="h-2.5 bg-gray-200 rounded w-16 animate-pulse" />
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <div className="h-3 bg-gray-200 rounded w-20 animate-pulse" />
                  <div className="h-2.5 bg-gray-200 rounded w-28 animate-pulse" />
                </div>
                <div className="flex flex-col gap-1">
                  <div className="h-4 bg-gray-200 rounded-full w-20 animate-pulse" />
                  <div className="h-2.5 bg-gray-200 rounded w-16 animate-pulse" />
                </div>
                <div>
                  <div className="h-8 bg-gray-200 rounded w-16 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl divide-y p-5 overflow-x-auto">
            <div className="min-w-[800px] max-h-[650px] overflow-y-auto">
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((leave) => (
                  <div
                    key={leave.id}
                    className="grid grid-cols-5 items-center py-4 px-6 border-b-[0.5px] border-[#D4D4D4] hover:bg-gray-50"
                  >
                    <div className="flex items-center gap-2">
                      {leave.avatar ? (
                        <img
                          src={leave.avatar}
                          alt={leave.name}
                          className="h-10 w-10 rounded-full object-cover"
                        />
                      ) : (
                        getAvarFromName(leave.name)
                      )}

                      <div>
                        <p className="text-[10px] font-semibold">{leave.name}</p>
                        <span
                          className={`inline-block px-2 py-0.5 rounded-full text-[7px] font-medium capitalize ${getRoleBadge(
                            leave.role
                          )}`}
                        >
                          {leave.role}
                        </span>
                      </div>
                    </div>

                    <div className="col-span-2">
                      <p className="text-[10px] mt-1">{formatDateRange(leave.date)}</p>
                      <p className="text-[8px] text-[#B9B9B9]">
                        {leave.description}
                      </p>
                    </div>

                    <div>
                      <span
                        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-semibold ${getStatusBadge(
                          leave.status
                        )}`}
                      >
                        {leave.status === 'approved' && (
                          <span className="mr-1.5 h-1 w-1 rounded-full bg-[#1B7F46]" />
                        )}
                        {leave.status === 'pending' && (
                          <span className="mr-1.5 h-1 w-1 rounded-full bg-[#D69E00]" />
                        )}
                        {leave.status === 'rejected' && (
                          <span className="mr-1.5 h-1 w-1 rounded-full bg-[#C42B1C]" />
                        )}
                        {leave.status.charAt(0).toUpperCase() +
                          leave.status.slice(1)}
                      </span>
                      <p className="text-[5px] text-[#575757] mt-1 flex flex-col font-semibold pl-1">
                        Deadline: {leave.deadline}
                      </p>
                    </div>

                    <div className="relative">
                      <button
                        onClick={() => openModal(leave)}
                        className="px-2 py-1 rounded-md flex items-center justify-between gap-2 bg-[#E2E2E2]"
                      >
                        <span className="text-[10px] text-black">Actions</span>
                        <MdOutlineKeyboardArrowDown
                          size={18}
                          className="text-[#AAA1A1]"
                        />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center p-10 text-center">
                  <img src={NoLeave} alt="no-leave" className="h-40 w-50" />
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {modalOpen && selectedLeave && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-96 shadow-xl">
            <h2 className="text-lg font-semibold mb-4">Manage Leave</h2>
            <hr className="border-t-[0.5px] border-[#D4D4D4] my-3 w-full" />

            <p className="text-xs mb-4">
              Employee: <span className="uppercase">{selectedLeave.name}</span>
            </p>

            <div className="flex flex-col gap-4 mt-6">
              <button
                onClick={handleApprove}
                className="bg-[#3ABE59] text-white p-4 rounded-md flex items-center justify-center"
                disabled={loading}
              >
                {loading && actionType === 'approve' ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : null}{' '}
                Approve the Leave{' '}
              </button>
              <button
                onClick={handleReject}
                className="bg-[#F97A7A] text-white p-4 rounded-md flex items-center justify-center"
                disabled={loading}
              >
                {loading && actionType === 'reject' ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : null} Reject
                the Leave
              </button>
              <button
                onClick={handleCloseModal}
                className="bg-[#F9F9F9] text-[#999999] p-4 rounded-md border-[0.5px] border-[#D4D4D4]"
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}

export default ManageLeave;
